export const CURRENCY_CODE_SIGN_MAPPING = {
    'cad':'$',
    'usd': '$',
    'gbp':'£'
}